// 全国主要城市经纬度数据
// 格式: 城市名: { lng: 经度, lat: 纬度 }

export const chinaCities = {
  // 直辖市
  北京市: { id: 110100, lng: 116.4074, lat: 39.9042 },
  上海市: { id: 310100, lng: 121.4737, lat: 31.2304 },
  天津市: { id: 120100, lng: 117.2008, lat: 39.0842 },
  重庆市: { id: 500100, lng: 106.5505, lat: 29.5636 },

  // 省会城市
  石家庄市: { id: 130100, lng: 114.5149, lat: 38.0428 },
  太原市: { id: 140100, lng: 112.5489, lat: 37.8576 },
  呼和浩特市: { id: 150100, lng: 111.6708, lat: 40.8183 },
  沈阳市: { id: 210100, lng: 123.4315, lat: 41.8057 },
  长春市: { id: 220100, lng: 125.3245, lat: 43.8869 },
  哈尔滨市: { id: 230100, lng: 126.534, lat: 45.8038 },
  南京市: { id: 320100, lng: 118.7969, lat: 32.0603 },
  杭州市: { id: 330100, lng: 120.1551, lat: 30.2741 },
  合肥市: { id: 340100, lng: 117.2272, lat: 31.8206 },
  福州市: { id: 350100, lng: 119.3062, lat: 26.0753 },
  南昌市: { id: 360100, lng: 115.8582, lat: 28.6829 },
  济南市: { id: 370100, lng: 117.0199, lat: 36.6712 },
  郑州市: { id: 410100, lng: 113.6654, lat: 34.7578 },
  武汉市: { id: 420100, lng: 114.2986, lat: 30.5844 },
  长沙市: { id: 430100, lng: 112.9823, lat: 28.1959 },
  广州市: { id: 440100, lng: 113.2644, lat: 23.1291 },
  南宁市: { id: 450100, lng: 108.3661, lat: 22.817 },
  海口市: { id: 460100, lng: 110.3312, lat: 20.0315 },
  成都市: { id: 510100, lng: 104.0661, lat: 30.5723 },
  贵阳市: { id: 520100, lng: 106.6302, lat: 26.6457 },
  昆明市: { id: 530100, lng: 102.8349, lat: 24.8792 },
  拉萨市: { id: 540100, lng: 91.1322, lat: 29.6604 },
  西安市: { id: 610100, lng: 108.948, lat: 34.2632 },
  兰州市: { id: 620100, lng: 103.8236, lat: 36.058 },
  西宁市: { id: 630100, lng: 101.7782, lat: 36.6171 },
  银川市: { id: 640100, lng: 106.2325, lat: 38.486 },
  乌鲁木齐市: { id: 650100, lng: 87.6177, lat: 43.7928 },

  // 河北省地级市
  唐山市: { id: 130200, lng: 118.1754, lat: 39.6351 },
  秦皇岛市: { id: 130300, lng: 119.5911, lat: 39.9425 },
  邯郸市: { id: 130400, lng: 114.4907, lat: 36.6123 },
  邢台市: { id: 130500, lng: 114.5089, lat: 37.0682 },
  保定市: { id: 130600, lng: 115.4823, lat: 38.8677 },
  张家口市: { id: 130700, lng: 114.8841, lat: 40.8119 },
  承德市: { id: 130800, lng: 117.9392, lat: 40.9762 },
  沧州市: { id: 130900, lng: 116.8575, lat: 38.3106 },
  廊坊市: { id: 131000, lng: 116.7044, lat: 39.5239 },
  衡水市: { id: 131100, lng: 115.6659, lat: 37.7351 },

  // 山西省地级市
  大同市: { id: 140200, lng: 113.2953, lat: 40.0903 },
  阳泉市: { id: 140300, lng: 113.5833, lat: 37.8611 },
  长治市: { id: 140400, lng: 113.1136, lat: 36.1911 },
  晋城市: { id: 140500, lng: 112.8513, lat: 35.4976 },
  朔州市: { id: 140600, lng: 112.4334, lat: 39.3313 },
  晋中市: { id: 140700, lng: 112.7466, lat: 37.6865 },
  运城市: { id: 140800, lng: 110.976, lat: 35.0264 },
  忻州市: { id: 140900, lng: 112.7342, lat: 38.4161 },
  临汾市: { id: 141000, lng: 111.519, lat: 36.0873 },
  吕梁市: { id: 141100, lng: 111.1343, lat: 37.5177 },

  // 内蒙古自治区地级市
  包头市: { id: 150200, lng: 109.8404, lat: 40.6582 },
  乌海市: { id: 150300, lng: 106.8256, lat: 39.6737 },
  赤峰市: { id: 150400, lng: 118.9593, lat: 42.2753 },
  通辽市: { id: 150500, lng: 122.2631, lat: 43.6172 },
  鄂尔多斯市: { id: 150600, lng: 109.9903, lat: 39.8172 },
  呼伦贝尔市: { id: 150700, lng: 119.7582, lat: 49.2153 },
  巴彦淖尔市: { id: 150800, lng: 107.4169, lat: 40.7574 },
  乌兰察布市: { id: 150900, lng: 113.1145, lat: 41.0341 },

  // 辽宁省地级市
  大连市: { id: 210200, lng: 121.6186, lat: 38.9146 },
  鞍山市: { id: 210300, lng: 122.9956, lat: 41.1106 },
  抚顺市: { id: 210400, lng: 123.9211, lat: 41.8759 },
  本溪市: { id: 210500, lng: 123.7669, lat: 41.2979 },
  丹东市: { id: 210600, lng: 124.3831, lat: 40.1243 },
  锦州市: { id: 210700, lng: 121.1357, lat: 41.1193 },
  营口市: { id: 210800, lng: 122.2352, lat: 40.6674 },
  阜新市: { id: 210900, lng: 121.6489, lat: 42.0118 },
  辽阳市: { id: 211000, lng: 123.1815, lat: 41.2694 },
  盘锦市: { id: 211100, lng: 122.0696, lat: 41.1244 },
  铁岭市: { id: 211200, lng: 123.8443, lat: 42.2906 },
  朝阳市: { id: 211300, lng: 120.4512, lat: 41.5768 },
  葫芦岛市: { id: 211400, lng: 120.8564, lat: 40.7556 },

  // 吉林省地级市
  吉林市: { id: 220200, lng: 126.553, lat: 43.8436 },
  四平市: { id: 220300, lng: 124.3504, lat: 43.1703 },
  辽源市: { id: 220400, lng: 125.1453, lat: 42.9027 },
  通化市: { id: 220500, lng: 125.9365, lat: 41.7212 },
  白山市: { id: 220600, lng: 126.4278, lat: 41.9425 },
  松原市: { id: 220700, lng: 124.8236, lat: 45.1182 },
  白城市: { id: 220800, lng: 122.8412, lat: 45.619 },

  // 黑龙江省地级市
  齐齐哈尔市: { id: 230200, lng: 123.9182, lat: 47.3543 },
  鸡西市: { id: 230300, lng: 130.9759, lat: 45.3001 },
  鹤岗市: { id: 230400, lng: 130.2775, lat: 47.3321 },
  双鸭山市: { id: 230500, lng: 131.1573, lat: 46.6434 },
  大庆市: { id: 230600, lng: 125.0315, lat: 46.5873 },
  伊春市: { id: 230700, lng: 128.8994, lat: 47.7248 },
  佳木斯市: { id: 230800, lng: 130.3616, lat: 46.8096 },
  七台河市: { id: 230900, lng: 131.0156, lat: 45.7713 },
  牡丹江市: { id: 231000, lng: 129.6186, lat: 44.5829 },
  黑河市: { id: 231100, lng: 127.499, lat: 50.2496 },
  绥化市: { id: 231200, lng: 126.9929, lat: 46.6373 },

  // 江苏省地级市
  无锡市: { id: 320200, lng: 120.3017, lat: 31.5747 },
  徐州市: { id: 320300, lng: 117.1848, lat: 34.2618 },
  常州市: { id: 320400, lng: 119.9741, lat: 31.7934 },
  苏州市: { id: 320500, lng: 120.5853, lat: 31.2989 },
  南通市: { id: 320600, lng: 120.8646, lat: 32.0162 },
  连云港市: { id: 320700, lng: 119.1782, lat: 34.5967 },
  淮安市: { id: 320800, lng: 119.0213, lat: 33.5975 },
  盐城市: { id: 320900, lng: 120.1631, lat: 33.3477 },
  扬州市: { id: 321000, lng: 119.421, lat: 32.3932 },
  镇江市: { id: 321100, lng: 119.4528, lat: 32.2044 },
  泰州市: { id: 321200, lng: 119.9152, lat: 32.4849 },
  宿迁市: { id: 321300, lng: 118.2752, lat: 33.963 },

  // 浙江省地级市
  宁波市: { id: 330200, lng: 121.5497, lat: 29.8742 },
  温州市: { id: 330300, lng: 120.6721, lat: 28.0036 },
  嘉兴市: { id: 330400, lng: 120.7509, lat: 30.7627 },
  湖州市: { id: 330500, lng: 120.1273, lat: 30.8672 },
  绍兴市: { id: 330600, lng: 120.5812, lat: 30.0301 },
  金华市: { id: 330700, lng: 119.6495, lat: 29.0895 },
  衢州市: { id: 330800, lng: 118.8726, lat: 28.9359 },
  舟山市: { id: 330900, lng: 122.1069, lat: 30.016 },
  台州市: { id: 331000, lng: 121.4286, lat: 28.6614 },
  丽水市: { id: 331100, lng: 119.9218, lat: 28.452 },

  // 安徽省地级市
  芜湖市: { id: 340200, lng: 118.3764, lat: 31.3263 },
  蚌埠市: { id: 340300, lng: 117.3632, lat: 32.9397 },
  淮南市: { id: 340400, lng: 117.0181, lat: 32.6476 },
  马鞍山市: { id: 340500, lng: 118.5079, lat: 31.6894 },
  淮北市: { id: 340600, lng: 116.7947, lat: 33.9558 },
  铜陵市: { id: 340700, lng: 117.8166, lat: 30.9299 },
  安庆市: { id: 340800, lng: 117.0436, lat: 30.5088 },
  黄山市: { id: 341000, lng: 118.3173, lat: 29.7092 },
  滁州市: { id: 341100, lng: 118.3163, lat: 32.3036 },
  阜阳市: { id: 341200, lng: 115.8197, lat: 32.8969 },
  宿州市: { id: 341300, lng: 116.9841, lat: 33.6339 },
  六安市: { id: 341500, lng: 116.5077, lat: 31.7542 },
  亳州市: { id: 341600, lng: 115.7793, lat: 33.8446 },
  池州市: { id: 341700, lng: 117.4892, lat: 30.656 },
  宣城市: { id: 341800, lng: 118.7582, lat: 30.9457 },

  // 福建省地级市
  厦门市: { id: 350200, lng: 118.0894, lat: 24.4797 },
  莆田市: { id: 350300, lng: 119.0076, lat: 25.431 },
  三明市: { id: 350400, lng: 117.635, lat: 26.2654 },
  泉州市: { id: 350500, lng: 118.5889, lat: 24.9086 },
  漳州市: { id: 350600, lng: 117.6515, lat: 24.5093 },
  南平市: { id: 350700, lng: 118.1785, lat: 26.6418 },
  龙岩市: { id: 350800, lng: 117.0298, lat: 25.0916 },
  宁德市: { id: 350900, lng: 119.5271, lat: 26.6593 },

  // 江西省地级市
  景德镇市: { id: 360200, lng: 117.2147, lat: 29.2926 },
  萍乡市: { id: 360300, lng: 113.8522, lat: 27.6229 },
  九江市: { id: 360400, lng: 115.9928, lat: 29.712 },
  新余市: { id: 360500, lng: 114.9308, lat: 27.8108 },
  鹰潭市: { id: 360600, lng: 117.0338, lat: 28.2386 },
  赣州市: { id: 360700, lng: 114.9339, lat: 25.8292 },
  吉安市: { id: 360800, lng: 114.9864, lat: 27.1117 },
  宜春市: { id: 360900, lng: 114.3911, lat: 27.8043 },
  抚州市: { id: 361000, lng: 116.3582, lat: 27.9839 },
  上饶市: { id: 361100, lng: 117.9712, lat: 28.4444 },

  // 山东省地级市
  青岛市: { id: 370200, lng: 120.3822, lat: 36.0666 },
  淄博市: { id: 370300, lng: 118.0476, lat: 36.8149 },
  枣庄市: { id: 370400, lng: 117.5579, lat: 34.8564 },
  东营市: { id: 370500, lng: 118.6647, lat: 37.4346 },
  烟台市: { id: 370600, lng: 121.3914, lat: 37.5393 },
  潍坊市: { id: 370700, lng: 119.1071, lat: 36.7092 },
  济宁市: { id: 370800, lng: 116.5872, lat: 35.4154 },
  泰安市: { id: 370900, lng: 117.1291, lat: 36.1949 },
  威海市: { id: 371000, lng: 122.1164, lat: 37.5097 },
  日照市: { id: 371100, lng: 119.4612, lat: 35.4286 },
  临沂市: { id: 371300, lng: 118.3263, lat: 35.0653 },
  德州市: { id: 371400, lng: 116.3075, lat: 37.454 },
  聊城市: { id: 371500, lng: 115.9804, lat: 36.456 },
  滨州市: { id: 371600, lng: 118.0193, lat: 37.3835 },
  菏泽市: { id: 371700, lng: 115.4694, lat: 35.2465 },

  // 河南省地级市
  开封市: { id: 410200, lng: 114.3414, lat: 34.7973 },
  洛阳市: { id: 410300, lng: 112.4345, lat: 34.663 },
  平顶山市: { id: 410400, lng: 113.2988, lat: 33.7353 },
  安阳市: { id: 410500, lng: 114.3525, lat: 36.1034 },
  鹤壁市: { id: 410600, lng: 114.1753, lat: 35.7472 },
  新乡市: { id: 410700, lng: 113.8536, lat: 35.3026 },
  焦作市: { id: 410800, lng: 113.2383, lat: 35.239 },
  濮阳市: { id: 410900, lng: 115.0292, lat: 35.7619 },
  许昌市: { id: 411000, lng: 113.8261, lat: 34.023 },
  漯河市: { id: 411100, lng: 114.0263, lat: 33.5759 },
  三门峡市: { id: 411200, lng: 111.1941, lat: 34.7773 },
  南阳市: { id: 411300, lng: 112.5409, lat: 32.9991 },
  商丘市: { id: 411400, lng: 115.6505, lat: 34.437 },
  信阳市: { id: 411500, lng: 114.0751, lat: 32.1233 },
  周口市: { id: 411600, lng: 114.6497, lat: 33.6204 },
  驻马店市: { id: 411700, lng: 114.0247, lat: 32.9802 },

  // 湖北省地级市
  黄石市: { id: 420200, lng: 115.0935, lat: 30.2122 },
  十堰市: { id: 420300, lng: 110.7879, lat: 32.6469 },
  宜昌市: { id: 420500, lng: 111.2908, lat: 30.7026 },
  襄阳市: { id: 420600, lng: 112.1441, lat: 32.0424 },
  鄂州市: { id: 420700, lng: 114.8906, lat: 30.3965 },
  荆门市: { id: 420800, lng: 112.1994, lat: 31.0354 },
  孝感市: { id: 420900, lng: 113.9267, lat: 30.9261 },
  荆州市: { id: 421000, lng: 112.2381, lat: 30.3269 },
  黄冈市: { id: 421100, lng: 114.8794, lat: 30.4477 },
  咸宁市: { id: 421200, lng: 114.3289, lat: 29.8328 },
  随州市: { id: 421300, lng: 113.3738, lat: 31.7175 },

  // 湖南省地级市
  株洲市: { id: 430200, lng: 113.1517, lat: 27.8358 },
  湘潭市: { id: 430300, lng: 112.9441, lat: 27.8297 },
  衡阳市: { id: 430400, lng: 112.6077, lat: 26.8932 },
  邵阳市: { id: 430500, lng: 111.4692, lat: 27.2378 },
  岳阳市: { id: 430600, lng: 113.1389, lat: 29.3667 },
  常德市: { id: 430700, lng: 111.6913, lat: 29.0402 },
  张家界市: { id: 430800, lng: 110.4799, lat: 29.1274 },
  益阳市: { id: 430900, lng: 112.355, lat: 28.5701 },
  郴州市: { id: 431000, lng: 113.0321, lat: 25.7936 },
  永州市: { id: 431100, lng: 111.6081, lat: 26.4345 },
  怀化市: { id: 431200, lng: 109.9782, lat: 27.5501 },
  娄底市: { id: 431300, lng: 112.0085, lat: 27.7281 },

  // 广东省地级市
  深圳市: { id: 440300, lng: 114.0579, lat: 22.5431 },
  珠海市: { id: 440400, lng: 113.5767, lat: 22.2707 },
  汕头市: { id: 440500, lng: 116.6819, lat: 23.3541 },
  佛山市: { id: 440600, lng: 113.1227, lat: 23.0288 },
  江门市: { id: 440700, lng: 113.0949, lat: 22.5904 },
  湛江市: { id: 440800, lng: 110.365, lat: 21.2575 },
  茂名市: { id: 440900, lng: 110.9192, lat: 21.6597 },
  肇庆市: { id: 441200, lng: 112.4725, lat: 23.0515 },
  惠州市: { id: 441300, lng: 114.4126, lat: 23.0794 },
  梅州市: { id: 441400, lng: 116.1176, lat: 24.2991 },
  汕尾市: { id: 441500, lng: 115.3642, lat: 22.7745 },
  河源市: { id: 441600, lng: 114.6978, lat: 23.7463 },
  阳江市: { id: 441700, lng: 111.9751, lat: 21.8592 },
  清远市: { id: 441800, lng: 113.0512, lat: 23.685 },
  东莞市: { id: 441900, lng: 113.7518, lat: 23.0207 },
  中山市: { id: 442000, lng: 113.3824, lat: 22.5211 },
  潮州市: { id: 445100, lng: 116.6323, lat: 23.6617 },
  揭阳市: { id: 445200, lng: 116.3557, lat: 23.5438 },
  云浮市: { id: 445300, lng: 112.0445, lat: 22.9298 },

  // 广西壮族自治区地级市
  柳州市: { id: 450200, lng: 109.4117, lat: 24.3146 },
  桂林市: { id: 450300, lng: 110.2991, lat: 25.2742 },
  梧州市: { id: 450400, lng: 111.2976, lat: 23.4748 },
  北海市: { id: 450500, lng: 109.1193, lat: 21.4733 },
  防城港市: { id: 450600, lng: 108.3455, lat: 21.6146 },
  钦州市: { id: 450700, lng: 108.6242, lat: 21.9671 },
  贵港市: { id: 450800, lng: 109.6021, lat: 23.0936 },
  玉林市: { id: 450900, lng: 110.1544, lat: 22.6314 },
  百色市: { id: 451000, lng: 106.6163, lat: 23.8977 },
  贺州市: { id: 451100, lng: 111.5521, lat: 24.4141 },
  河池市: { id: 451200, lng: 108.0621, lat: 24.6959 },
  来宾市: { id: 451300, lng: 109.2298, lat: 23.7338 },
  崇左市: { id: 451400, lng: 107.3538, lat: 22.4041 },

  // 海南省地级市
  三亚市: { id: 460200, lng: 109.5083, lat: 18.2479 },
  三沙市: { id: 460300, lng: 112.3488, lat: 16.831 },
  儋州市: { id: 460400, lng: 109.5768, lat: 19.5175 },

  // 四川省地级市
  自贡市: { id: 510300, lng: 104.7734, lat: 29.3527 },
  攀枝花市: { id: 510400, lng: 101.716, lat: 26.5804 },
  泸州市: { id: 510500, lng: 105.443, lat: 28.8891 },
  德阳市: { id: 510600, lng: 104.3986, lat: 31.1276 },
  绵阳市: { id: 510700, lng: 104.7417, lat: 31.464 },
  广元市: { id: 510800, lng: 105.8298, lat: 32.4337 },
  遂宁市: { id: 510900, lng: 105.5713, lat: 30.5138 },
  内江市: { id: 511000, lng: 105.0661, lat: 29.5871 },
  乐山市: { id: 511100, lng: 103.7612, lat: 29.5828 },
  南充市: { id: 511300, lng: 106.0825, lat: 30.7953 },
  眉山市: { id: 511400, lng: 103.8318, lat: 30.0483 },
  宜宾市: { id: 511500, lng: 104.6308, lat: 28.7602 },
  广安市: { id: 511600, lng: 106.6334, lat: 30.4564 },
  达州市: { id: 511700, lng: 107.5023, lat: 31.2095 },
  雅安市: { id: 511800, lng: 103.001, lat: 29.9877 },
  巴中市: { id: 511900, lng: 106.7537, lat: 31.8588 },
  资阳市: { id: 512000, lng: 104.6419, lat: 30.1222 },

  // 贵州省地级市
  六盘水市: { id: 520200, lng: 104.8467, lat: 26.5846 },
  遵义市: { id: 520300, lng: 106.9273, lat: 27.7257 },
  安顺市: { id: 520400, lng: 105.9322, lat: 26.2455 },
  毕节市: { id: 520500, lng: 105.285, lat: 27.3017 },
  铜仁市: { id: 520600, lng: 109.1916, lat: 27.7183 },

  // 云南省地级市
  曲靖市: { id: 530300, lng: 103.7979, lat: 25.5016 },
  玉溪市: { id: 530400, lng: 102.5439, lat: 24.3505 },
  保山市: { id: 530500, lng: 99.1671, lat: 25.1118 },
  昭通市: { id: 530600, lng: 103.7172, lat: 27.336 },
  丽江市: { id: 530700, lng: 100.233, lat: 26.8721 },
  普洱市: { id: 530800, lng: 100.9723, lat: 22.7773 },
  临沧市: { id: 530900, lng: 100.0869, lat: 23.8866 },

  // 西藏自治区地级市
  日喀则市: { id: 540200, lng: 88.8858, lat: 29.2675 },
  昌都市: { id: 540300, lng: 97.1785, lat: 31.1369 },
  林芝市: { id: 540400, lng: 94.3623, lat: 29.6546 },
  山南市: { id: 540500, lng: 91.7665, lat: 29.236 },
  那曲市: { id: 540600, lng: 92.0602, lat: 31.476 },
  阿里地区: { id: 542500, lng: 80.1055, lat: 32.5032 },

  // 陕西省地级市
  铜川市: { id: 610200, lng: 108.9796, lat: 34.9166 },
  宝鸡市: { id: 610300, lng: 107.1449, lat: 34.3693 },
  咸阳市: { id: 610400, lng: 108.7051, lat: 34.3334 },
  渭南市: { id: 610500, lng: 109.5029, lat: 34.4994 },
  延安市: { id: 610600, lng: 109.4908, lat: 36.5965 },
  汉中市: { id: 610700, lng: 107.0286, lat: 33.0777 },
  榆林市: { id: 610800, lng: 109.7412, lat: 38.2902 },
  安康市: { id: 610900, lng: 109.0293, lat: 32.6903 },
  商洛市: { id: 611000, lng: 109.9398, lat: 33.8683 },

  // 甘肃省地级市
  嘉峪关市: { id: 620200, lng: 98.2773, lat: 39.7865 },
  金昌市: { id: 620300, lng: 102.1879, lat: 38.5142 },
  白银市: { id: 620400, lng: 104.1736, lat: 36.5457 },
  天水市: { id: 620500, lng: 105.725, lat: 34.5785 },
  武威市: { id: 620600, lng: 102.6349, lat: 37.9291 },
  张掖市: { id: 620700, lng: 100.4555, lat: 38.9329 },
  平凉市: { id: 620800, lng: 106.6847, lat: 35.5427 },
  酒泉市: { id: 620900, lng: 98.5108, lat: 39.744 },
  庆阳市: { id: 621000, lng: 107.6384, lat: 35.7342 },
  定西市: { id: 621100, lng: 104.6263, lat: 35.5796 },
  陇南市: { id: 621200, lng: 104.9294, lat: 33.3886 },

  // 青海省地级市
  海东市: { id: 630200, lng: 102.1036, lat: 36.5022 },
  海北藏族自治州: { id: 632200, lng: 100.9011, lat: 36.9595 },
  黄南藏族自治州: { id: 632300, lng: 102.0199, lat: 35.5178 },
  海南藏族自治州: { id: 632500, lng: 100.6195, lat: 36.2804 },
  果洛藏族自治州: { id: 632600, lng: 100.2421, lat: 34.4736 },
  玉树藏族自治州: { id: 632700, lng: 97.0085, lat: 33.0045 },
  海西蒙古族藏族自治州: { id: 632800, lng: 97.3708, lat: 37.3746 },

  // 宁夏回族自治区地级市
  石嘴山市: { id: 640200, lng: 106.3762, lat: 39.0133 },
  吴忠市: { id: 640300, lng: 106.1994, lat: 37.9862 },
  固原市: { id: 640400, lng: 106.2852, lat: 36.0046 },
  中卫市: { id: 640500, lng: 105.1896, lat: 37.5147 },

  // 新疆维吾尔自治区地级市
  克拉玛依市: { id: 650200, lng: 84.8739, lat: 45.5959 },
  吐鲁番市: { id: 650400, lng: 89.1841, lat: 42.9476 },
  哈密市: { id: 650500, lng: 93.5132, lat: 42.8332 },
  昌吉回族自治州: { id: 652300, lng: 87.3041, lat: 44.0146 },
  博尔塔拉蒙古自治州: { id: 652700, lng: 82.0748, lat: 44.9032 },
  巴音郭楞蒙古自治州: { id: 652800, lng: 86.1508, lat: 41.7686 },
  阿克苏地区: { id: 652900, lng: 80.2651, lat: 41.1707 },
  克孜勒苏柯尔克孜自治州: { id: 653000, lng: 76.1728, lat: 39.7134 },
  喀什地区: { id: 653100, lng: 75.9891, lat: 39.4872 },
  和田地区: { id: 653200, lng: 79.9253, lat: 37.1107 },
  伊犁哈萨克自治州: { id: 654000, lng: 81.3179, lat: 43.9223 },
  塔城地区: { id: 654200, lng: 82.9857, lat: 46.7463 },
  阿勒泰地区: { id: 654300, lng: 88.1396, lat: 47.8484 },

  // 主要县级市
  福清市: { id: 350181, lng: 119.3842, lat: 25.7204 },
  青宁市: { id: 640200, lng: 106.2546, lat: 38.2774 }
} as const

export type CityName = keyof typeof chinaCities
export type CityLocation = (typeof chinaCities)[CityName]

/**
 * 根据城市名称获取对应的经纬度数据
 * @param cityName 城市名称
 * @returns 城市的经纬度数据，如果未找到则返回undefined
 */
export const getCityLocation = (cityName: string): CityLocation | undefined => {
  if (!cityName) {
    return undefined
  }
  const direct = chinaCities[cityName as CityName]
  if (direct) {
    return direct
  }
  // 兼容环境变量写「成都」而城市表为「成都市」的情况
  const withShi = cityName.endsWith('市') ? cityName : `${cityName}市`
  return chinaCities[withShi as CityName]
}

/** 地图中心点兜底（大庆通学场景默认大庆市） */
export const getDefaultMapCenter = (
  cityName?: string
): { lng: number; lat: number } => {
  const loc =
    getCityLocation(cityName || '') ||
    getCityLocation('大庆市') ||
    getCityLocation('成都市')
  return { lng: loc?.lng ?? 125.0315, lat: loc?.lat ?? 46.5873 }
}

/**
 * 根据城市ID获取对应的城市名称
 * @param cityId 城市ID
 * @returns 城市名称，如果未找到则返回undefined
 */
export const getCityNameById = (cityId: number): CityName | undefined => {
  for (const [cityName, cityInfo] of Object.entries(chinaCities)) {
    if (cityInfo.id === cityId) {
      return cityName as CityName
    }
  }
  return undefined
}

/**
 * 根据城市ID前缀获取可能匹配的城市名称
 * 支持通过4位或6位ID查找城市
 * @param cityIdPrefix 城市ID前缀(4位)或完整ID(6位)
 * @returns 城市名称，如果未找到则返回undefined
 */
export const getCityNameByIdPrefix = (cityIdPrefix: number): CityName | undefined => {
  if (!cityIdPrefix) {
    return undefined
  }
  // 转换为字符串以检查长度
  const idStr = cityIdPrefix.toString()

  // 如果是4位数ID前缀，转换为6位完整ID（后面补两个0）
  let fullId = cityIdPrefix
  if (idStr.length === 4) {
    fullId = cityIdPrefix * 100
  }

  // 使用完整ID查找城市
  return getCityNameById(fullId)
}

export default chinaCities
